let adblockStatus: 'blocked' | 'not-blocked' | 'unknown' = 'unknown'
type AdblockStatus = 'blocked' | 'not-blocked' | 'unknown'

export const getAdblockStatus = (): AdblockStatus => adblockStatus
export const setAdblockStatus = (status: AdblockStatus): void => {
  adblockStatus = status
}
